/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { Box, IconButton, Snackbar, Typography } from "@mui/material";
import { useAppDispatch, useAppSelector } from "app/hooks";
import { iconButtons, iconTokens, tokenActionTypeEnum, walletStepEnum } from "libs/constans";
import { Fragment } from "react";
import { changePopupAction, changePopupStep, popupSelector, setPrevStep } from "./popupSlice";
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import React from "react";
import History from "components/History";

const bg_styles = {
    position: 'absolute',
    zIndex: -1,
    textAlign: 'center',
    p: 2,
    background: `linear-gradient(90deg, #BF26E6 -5.41%, #3C14DA 100%)`,
    width: '100%',
    left: 0,
    top: 0,
    height: 220,
} as const;

export function TokenDetails() {

    const { wallet, token, ratio } = useAppSelector(popupSelector);
    const dispatch = useAppDispatch();

    const [open, setOpen] = React.useState(false);
    const [info, setInfo] = React.useState('');

    const handleTransfer = () => {
        dispatch(setPrevStep(walletStepEnum.TOKEN_DETAILS));
        dispatch(changePopupAction(tokenActionTypeEnum.SEND))
        dispatch(changePopupStep(walletStepEnum.SEND_TOKEN))
    }
    const handleReceive = () => {
        dispatch(setPrevStep(walletStepEnum.TOKEN_DETAILS));
        dispatch(changePopupAction(tokenActionTypeEnum.RECEIVE))
        dispatch(changePopupStep(walletStepEnum.RECEIVE_TOKEN))
    }
    const handleCopy = () => {
        const address = token && token.tokenAddress? token.tokenAddress: wallet?.address;
        if(address){
            navigator.clipboard.writeText(address);
            setInfo('Copied');
            setOpen(true);
        }else{
            setInfo('No address found');
            setOpen(true);
        }
        
    }
    const handleMore = () => {

    }

    const handleClose = (
        event: React.SyntheticEvent | React.MouseEvent,
        reason?: string,
    ) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpen(false);
    };

    if (!token) {
        return <></>
    }

    const history = true
    const amountUSDTString = (parseFloat(token.balance) * ratio[token.symbol]).toFixed(2);

    return (
        <Fragment>
            <WalletNav title="Token Details" />
            <Snackbar
                open={open}
                autoHideDuration={3000}
                onClose={handleClose}
                message={info}
            />
            <Box>
                <Box sx={bg_styles}>
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center',
                            width: '100%',
                            mt: 5,
                        }}
                    >
                        <object data={iconTokens[token.symbol]} width={60} height={60}> </object>
                        <Typography sx={{ fontSize: '20px', fontWeight: 600, m: 1 }}>{token.balance}&nbsp;{token.symbol}</Typography>
                        <Typography sx={{ fontSize: '13px' }}>{`$`}{amountUSDTString}</Typography>
                    </Box>
                </Box>
                <Box sx={{ height: 110 }}></Box>
                <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                    <Box sx={{ textAlign: 'center', backgroundColor: "#ffffff", width: 50, height: 50, borderRadius: '50%', mx: 1 }}>
                        <IconButton onClick={handleTransfer} sx={{ backgroundColor: "#ffffff", width: 50, height: 50 }}>
                            <img alt="" src={iconButtons.TRANSFER} width={20} />
                        </IconButton>
                        <Typography sx={{ fontSize: '13px' }}>{`Transfer`}</Typography>
                    </Box>
                    <Box sx={{ textAlign: 'center', backgroundColor: "#ffffff", width: 50, height: 50, borderRadius: '50%', mx: 1 }}>
                        <IconButton onClick={handleReceive} sx={{ backgroundColor: "#ffffff", width: 50, height: 50 }}>
                            <img alt="" src={iconButtons.RECEIVE} width={20} />
                        </IconButton>
                        <Typography sx={{ fontSize: '13px' }}>{`Receive`}</Typography>
                    </Box>
                    <Box sx={{ textAlign: 'center', backgroundColor: "#ffffff", width: 50, height: 50, borderRadius: '50%', mx: 1 }}>
                        <IconButton onClick={handleCopy} sx={{ backgroundColor: "#ffffff", width: 50, height: 50 }}>
                            <img alt="" src={iconButtons.COPY} width={20} />
                        </IconButton>
                        <Typography sx={{ fontSize: '13px' }}>{`Copy`}</Typography>
                    </Box>
                   {/*  <Box sx={{ textAlign: 'center', backgroundColor: "#ffffff", width: 50, height: 50, borderRadius: '50%', mx: 1 }}>
                        <IconButton onClick={handleMore} sx={{ backgroundColor: "#ffffff", width: 50, height: 50 }}>
                            <img alt="" src={iconButtons.MORE} width={20} />
                        </IconButton>
                        <Typography sx={{ fontSize: '13px' }}>{`More`}</Typography>
                    </Box>
 */}                </Box>
                <Box sx={{ mt: 4, p: 1 }}>
                    <Typography sx={{ fontSize: '13px', color: '#B1BBD2' }}>{`HISTORY`}</Typography>
                    <History
                        address={wallet?.address}
                        contractAddress={token.tokenAddress}
                    />
                </Box>

            </Box>
        </Fragment>
    );
}


export function WalletNav({ title }: { title: string }) {

    const dispatch = useAppDispatch();

    const handleBack = () => {
        dispatch(changePopupStep(walletStepEnum.WALLET_DETAILS))
    }

    return (
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 4 }}>
            <IconButton onClick={handleBack}>
                <KeyboardBackspaceIcon />
            </IconButton>
            <Typography sx={{ fontSize: '16px', fontWeight: '500' }}>{title}</Typography>
            <IconButton>

            </IconButton>
        </Box>
    );
}